import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FileUploader } from 'ng2-file-upload';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
})
export class FileUploadComponent implements OnInit {
  uploadForm: FormGroup;

  isUploading = false;

  uploadedFiles = [];

  public uploader: FileUploader = new FileUploader({
    isHTML5: true,
  });

  constructor(private formBuilder: FormBuilder, private http: HttpClient) {}

  submitForm() {
    this.isUploading = true;

    this.uploader.queue.map((queue) => {
      const fileItem = queue._file;

      if (fileItem.size > 10000000) {
        alert('Cada arquivo deve conter menos de 10MB de tamanho.');
        return;
      }

      this.uploadedFiles.push(fileItem);
    });

    this.uploader.clearQueue();

    this.isUploading = false;
  }

  uploadFile(data: FormData): Observable<any> {
    return this.http.post<any>('http://localhost:8080/upload', data);
  }

  ngOnInit() {
    this.uploadForm = this.formBuilder.group({
      document: [null, null],
      type: [null, Validators.compose([Validators.required])],
    });
  }

  deleteUploadedFile(file: any) {
    // TODO :: Add backend delete call on file.id
    this.uploadedFiles = this.uploadedFiles.filter(
      (uploadedFile) => uploadedFile.name !== file.name
    );
  }
}
